// extracted by mini-css-extract-plugin
module.exports = {"dark":"Wrapper-module--dark--2cW3j","light":"Wrapper-module--light--3k8aG"};